import { createUseStyles } from 'react-jss'
import { textEllipsisMultiline } from '../../../../../styles/mixins/text'
import { darkGrey } from '../../../../../styles/const/colors'

export const singleAdThumbnailHeight = '240px'

export default createUseStyles({
  adFooter: {
    padding: '8px 12px',
    display: 'flex',
    gap: 10,
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  footerInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexShrink: 1
  },
  footerWebsite: {
    fontSize: 8,
    textTransform: 'uppercase'
  },
  footerDescription: {
    fontSize: 9,
    fontWeight: 400,
    color: darkGrey
  },

  // HEADLINE
  singleHeadlineText: {
    margin: '2px 0 2px',
    fontSize: 11,
    // textEllipsisMultiline is used instead of textEllipsis because textEllipsis works incorrectly
    // when parent element has display: flexShrink: 1
    ...textEllipsisMultiline(1)
  },
  skeletonSingleHeadline: {
    maxHeight: 10,
    height: 10
  },

  // DESCRIPTION
  singleDescriptionText: {
    fontSize: 9
  }
})
